module.exports = __webpack_public_path__ + "static/media/FZCOStamp.023d2b2e.png";